import { render, staticRenderFns } from "./NewPassword.vue?vue&type=template&id=599890b2&scoped=true&"
import script from "./NewPassword.vue?vue&type=script&lang=js&"
export * from "./NewPassword.vue?vue&type=script&lang=js&"
import style0 from "./NewPassword.vue?vue&type=style&index=0&id=599890b2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599890b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VContent,VImg,VRow,VSpacer})
